<template>
  <div>
    <NavBar :user="user"></NavBar>

    <section class="detail-layout transfer" id="transfer-details" v-if="item">
      <!-- header -->
      <div class="detail-header transfer-header">
        <div class="container">
          <div v-if="missingDepartureOrArrival">
            <h2 style="color:red" class="text-center">
              <translate>
                "ERROR! TRANSFER IS MISSING EITHER DEPARTURE OR ARRIVAL.
              </translate>
            </h2>
          </div>
          <div v-else class="row">
            <div class="col-12">
              <h3>
                <i class="material-icons">timeline</i>
                {{ item.code }} |
                <span class="status">{{ item.statusHuman }}</span>
              </h3>
              <h1>
                {{ item.origin.address.locality }}
                <i class="material-icons">arrow_forward</i>
                {{ item.destination.address.locality }}
              </h1>
              <div class="inline-item">
                <i class="material-icons icon-space">access_time</i>
                <translate class="colon-space">ETA:</translate>
                <span class="black">
                  {{ item.arrival.effectiveActualTime | calendar }}
                </span>
              </div>
              <div class="inline-item" v-if="item.order">
                <i class="material-icons icon-space">bookmark_border</i>
                <translate class="colon-space">Ref:</translate>
                <span class="black">{{ item.order.referenceNumber }}</span>
              </div>
              <div class="inline-item">
                <i class="material-icons icon-space">fingerprint</i>
                <translate class="colon-space">ID:</translate>
                <span class="black">{{ item.id }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ul class="nav nav-tabs nav-fill" id="transfer-tab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="overview-tab"
                    data-toggle="tab"
                    href="#overview"
                    role="tab"
                    aria-controls="overview"
                    aria-expanded="true"
                    v-translate
                  >
                    Overview
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="route-tab"
                    data-toggle="tab"
                    href="#route"
                    v-on:click="renderMapDelayed"
                    role="tab"
                    aria-controls="route"
                    v-translate
                  >
                    Route progress
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="activity-tab"
                    data-toggle="tab"
                    href="#activity"
                    role="tab"
                    aria-controls="activity"
                    v-translate
                  >
                    Activity
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="notifications-tab"
                    data-toggle="tab"
                    href="#notifications"
                    role="tab"
                    aria-controls="notifications"
                  >
                    Notifications
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="documents-tab"
                    data-toggle="tab"
                    href="#documents"
                    role="tab"
                    aria-controls="documents"
                    v-translate
                  >
                    Documents
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.header-->

      <div class="detail-content transfer-content tab-content" id="transfer-content">
        <div
          class="transfer-overview tab-pane show active"
          id="overview"
          role="tabpanel"
          aria-labelledby="overview-tab"
        >
          <div class="container">
            <div class="row">
              <div class="col col-lg-4 col-md-6 col-12">
                <div class="card" data-test="basic-card">
                  <div class="card-body">
                    <h4 class="card-title">
                      <translate>Basic:</translate>
                    </h4>

                    <div class="card-item" :name="item.code">
                      <div class="card-item-icon">
                        <i class="material-icons">timeline</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Line:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">
                          {{ item.code }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="card-item"
                      :name="item.order.referenceNumber"
                      v-if="item.order"
                    >
                      <div class="card-item-icon">
                        <i class="material-icons">bookmark_border</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Reference No:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">
                          {{ item.order.referenceNumber }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item">
                      <div class="card-item-icon">
                        <i class="material-icons">fingerprint</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>ID:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">{{ item.id }}</div>
                      </div>
                    </div>
                    <div class="card-item" :name="item.statusHuman">
                      <div class="card-item-icon">
                        <i class="material-icons">check</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Status:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">
                          {{ item.statusHuman }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col col-lg-4 col-md-6 col-12">
                <div class="card" data-test="route-card">
                  <div class="card-body">
                    <h4 class="card-title">
                      <translate>Route:</translate>
                    </h4>

                    <div class="card-item">
                      <div class="card-item-icon">
                        <i class="material-icons">access_time</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>ETA:</translate>
                        </h4>
                        <div
                          class="card-item-text card-item-text-big"
                          v-if="item.arrival"
                        >
                          {{ item.arrival.effectiveActualTime | calendar }}
                        </div>
                      </div>
                    </div>

                    <div class="card-item card-route card-from">
                      <div class="card-item-icon">
                        <i class="material-icons">place</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>From:</translate>
                        </h4>
                        <div class="card-item-text" v-if="item.origin">
                          <div class="card-adress-name">{{ item.origin.name }}</div>
                          <div>
                            {{ item.origin.address.route }}
                            {{ item.origin.address.streetNumber }},
                          </div>
                          <div>
                            {{ item.origin.address.postalCode }}
                            {{ item.origin.address.locality }} ({{
                              item.origin.address.country
                            }})
                          </div>
                        </div>
                        <h4 class="card-item-header">
                          <translate>Loading date:</translate>
                        </h4>
                        <div class="card-item-text" v-if="item.departure">
                          <strong>{{ item.departure.scheduledTime | date }}</strong>
                          <div class="card-scheduled-time">
                            <translate>Departure by</translate>
                            {{ item.departure.scheduledTime | time }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-item card-route card-to">
                      <div class="card-item-icon">
                        <i class="material-icons">place</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>To:</translate>
                        </h4>
                        <div class="card-item-text" v-if="item.destination">
                          <div class="card-adress-name">{{ item.destination.name }}</div>
                          <div>
                            {{ item.destination.address.route }}
                            {{ item.destination.address.streetNumber }},
                          </div>
                          <div>
                            {{ item.destination.address.postalCode }}
                            {{ item.destination.address.locality }} ({{
                              item.destination.address.country
                            }})
                          </div>
                        </div>
                        <h4 class="card-item-header">
                          <translate>Unloading date:</translate>
                        </h4>
                        <div class="card-item-text" v-if="item.arrival">
                          <strong>{{ item.arrival.scheduledTime | date }}</strong>
                          <div class="card-scheduled-time">
                            <translate>Arrival by</translate>
                            {{ item.arrival.scheduledTime | time }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col col-lg-4 col-md-6 col-12">
                <div class="card" data-test="truck-card">
                  <div class="card-body">
                    <h4 class="card-title">
                      <translate>Truck:</translate>
                    </h4>

                    <div class="card-item">
                      <div class="card-item-icon">
                        <i class="material-icons">local_shipping</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Vehicle type:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">
                          {{ item.dispatchedVehicle }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item">
                      <div class="card-item-icon">
                        <i class="material-icons">confirmation_number</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>License plate:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">
                          {{ item.licensePlate || '-' }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item">
                      <div class="card-item-icon">
                        <i class="material-icons">confirmation_number</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Trailer license plate:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">
                          {{ item.trailerLicensePlate || '-' }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-if="user.inStaffGroup && item.driver">
                      <div class="card-item-icon">
                        <i class="material-icons">person</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Driver:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-big">
                          <div>
                            {{ item.driver.firstName }} {{ item.driver.lastName }}
                          </div>
                          <div v-if="item.driver.phone">
                            <a :href="'tel:' + item.driver.phone">
                              {{ item.driver.phone }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="card-item"
                      v-if="user.inStaffGroup & (item.trackers.length > 0)"
                    >
                      <div class="card-item-icon">
                        <i class="material-icons">smartphone</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Trackers:</translate>
                        </h4>
                        <div class="card-item-text">
                          <div v-for="tracker in item.trackers" :key="tracker.name">
                            <a :href="'/trackers/' + tracker.id">{{ tracker.name }}</a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-item" v-if="item.arrival && !item.arrival.isDone">
                      <div class="card-item-icon">
                        <i class="material-icons">gps_fixed</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>GPS:</translate>
                        </h4>
                        <div class="card-item-text">
                          <span class="gps_online" v-if="item.gpsIsOnline" v-translate>
                            Online
                          </span>
                          <span v-else v-translate>Offline</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col col-lg-4 col-md-6 col-12" v-if="item.order">
                <div class="card" data-test="customer-card">
                  <div class="card-body">
                    <h4 class="card-title">
                      <translate>Customer:</translate>
                    </h4>

                    <div class="card-item" v-if="item.customerCompany">
                      <div class="card-item-icon">
                        <i class="material-icons">person_pin</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Name:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.customerCompany.name }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-if="item.customerContact">
                      <div class="card-item-icon">
                        <i class="material-icons">person_outline</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Contact:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{
                            item.customerContact.formatted
                              ? item.customerContact.formatted
                              : '-'
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-if="item.customerContact">
                      <div class="card-item-icon">
                        <i class="material-icons">phone</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Contact number:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{
                            item.customerContact.phone ? item.customerContact.phone : '-'
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-if="item.customerContact">
                      <div class="card-item-icon">
                        <i class="material-icons">email</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Contact email:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{
                            item.customerContact.email ? item.customerContact.email : '-'
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col col-lg-4 col-md-6 col-12" v-if="item.order">
                <div class="card" data-test="carrier-card">
                  <div class="card-body">
                    <h4 class="card-title">
                      <translate>Carrier:</translate>
                    </h4>

                    <div class="card-item" v-if="item.carrierCompany">
                      <div class="card-item-icon">
                        <i class="material-icons">local_shipping</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Name:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.carrierCompany.name }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-if="item.carrierContact">
                      <div class="card-item-icon">
                        <i class="material-icons">person_outline</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Contact:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.carrierContact.formatted || '-' }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-if="item.carrierContact">
                      <div class="card-item-icon">
                        <i class="material-icons">phone</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Contact number:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.carrierContact.phone || '-' }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-if="item.carrierContact">
                      <div class="card-item-icon">
                        <i class="material-icons">email</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Contact email:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.carrierContact.email || '-' }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="card-item"
                      v-if="user.inStaffGroup && item.carrierCompany"
                    >
                      <div class="card-item-icon">
                        <i class="material-icons">phone</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Emergency number:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.carrierCompany.emergencyPhoneNumber || '-' }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="card-item"
                      v-if="user.inStaffGroup && item.carrierCompany"
                    >
                      <div class="card-item-icon">
                        <i class="material-icons">comment</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Emergency number comments:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.carrierCompany.emergencyNumberComments || '-' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col col-lg-4 col-md-6 col-12"
                v-if="metaInfo.length || item.notes"
              >
                <div class="card" data-test="additional-card">
                  <div class="card-body">
                    <h4 class="card-title">
                      <translate>Additional:</translate>
                    </h4>

                    <div class="card-item" v-if="item.notes">
                      <div class="card-item-icon">
                        <i class="material-icons">add</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">
                          <translate>Additional information:</translate>
                        </h4>
                        <div class="card-item-text card-item-text-medium">
                          {{ item.notes }}
                        </div>
                      </div>
                    </div>
                    <div class="card-item" v-for="info in metaInfo" :key="info.meta">
                      <div class="card-item-icon">
                        <i class="material-icons">edit</i>
                      </div>
                      <div class="card-item-content">
                        <h4 class="card-item-header">{{ info.name }}:</h4>
                        <div class="card-item-text">
                          <span v-if="info.value">{{ info.value }}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="transfer-route tab-pane fade"
          id="route"
          role="tabpanel"
          aria-labelledby="route-tab"
        >
          <div class="container">
            <div class="row no-gutters map-box">
              <div class="col-lg-4 col-md-12 col-12">
                <div class="route-steps">
                  <h4 class="card-title">
                    <translate>Timeline:</translate>
                  </h4>
                  <TransferStep
                    v-for="(step, index) in item.steps"
                    :key="step.id"
                    :index="index"
                    :step="step"
                    :stepId="step.id"
                    :totalStepCount="item.steps.length"
                    :latestCompletedStep="item.latestCompletedStep"
                  ></TransferStep>
                </div>
              </div>
              <div class="col-lg-8 col-md-12 col-12">
                <div class="map-wrapper">
                  <div id="map">
                    <div id="leaflet"></div>
                  </div>
                  <div class="caption" v-if="item.lastUpdate">
                    <translate>Last gps update:</translate>
                    {{ item.lastUpdate | date }} {{ item.lastUpdate | time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="transfer-activity tab-pane fade"
          id="activity"
          role="tabpanel"
          aria-labelledby="activity-tab"
        >
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h4 class="card-title">
                  <translate>Activity:</translate>
                </h4>
              </div>
              <MessageItem
                v-for="message in item.messages"
                :key="message.timestamp"
                ref="message"
                :message="message"
                :timestamp="message.timestamp"
                :oldestTimestamp="item.oldestMessage.timestamp"
              ></MessageItem>
            </div>
          </div>
        </div>

        <div
          class="transfer-notifications tab-pane fade"
          id="notifications"
          role="tabpanel"
          aria-labelledby="notifications-tab"
        >
          <div class="container">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">
                  <translate>Notifications:</translate>
                </h4>
                <div class="row cards">
                  <NotificationCard
                    v-for="filter in item.filters"
                    :key="filter.name"
                    ref="notification"
                    :filter="filter"
                    :transfer="item"
                    @filtersChanged="loadFilters"
                  />
                  <AddNotificationCard :transfer="item" @filtersChanged="loadFilters" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="transfer-documents tab-pane fade"
          id="documents"
          role="tabpanel"
          aria-labelledby="documents-tab"
        >
          <div class="container">
            <div class="transfer-docs">
              <div class="row">
                <div class="col-12">
                  <h4 class="card-title">
                    <translate>Documents:</translate>
                  </h4>
                </div>
                <div class="col-md-4 col-sm-6 col-12">
                  <div class="card">
                    <a href="#" id="generateWaybill" v-on:click.once="generateWaybill">
                      <img
                        src="../../assets/img/waybill_mockup.png"
                        class="card-img-top"
                        alt="Waybill"
                      />
                    </a>
                    <div class="card-body">
                      <p class="card-text">
                        <a href="#" v-on:click.once="generateWaybill" v-translate>
                          Download Waybill
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="transfer-img" v-if="item.pictureSteps.length > 0">
              <div class="row">
                <div class="col-12">
                  <h4 class="card-title">
                    <translate>Pictures:</translate>
                  </h4>
                </div>
                <div
                  class="col-md-4 col-sm-6 col-12 uploaded-images"
                  v-for="picture in item.pictureSteps"
                  :key="picture"
                >
                  <div class="card">
                    <a :href="picture.photoUrl">
                      <img
                        :src="picture.photoUrl"
                        class="card-img-top"
                        alt="item.picture"
                      />
                    </a>
                    <div class="card-body" v-if="picture.noteFromDriver">
                      <p class="card-text">{{ picture.noteFromDriver }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import DetailMap from '../../controllers/detail-map'
import baseController from '../../controllers/base'
import Transfer from '../../models/transfer'
import Order from '../../models/order'
import Filter from '../../models/filter'
import NavBar from '../common/NavBar'
import TransferStep from './TransferStep'
import NotificationCard from './NotificationCard'
import AddNotificationCard from './AddNotificationCard'
import MessageItem from './MessageItem'
import {
  queryTransfer,
  queryFiltersForTransfer,
  queryOrderForTransferDetails,
  queryTransferMetaInfo
} from './queries'

export default {
  extends: baseController,
  components: {
    NavBar,
    TransferStep,
    NotificationCard,
    AddNotificationCard,
    MessageItem
  },
  props: ['user'],
  data() {
    return {
      id: null,
      item: null,
      transferMetaInfos: null
    }
  },
  computed: {
    metaInfo() {
      let infos = []
      // get the global meta info
      if (this.item.metaInfo) {
        infos = Object.entries(this.item.metaInfo).map(([key, value]) => ({
          name: this.transferMetaInfos[key] || key,
          value
        }))
      }

      // add the meta info that is collected in the steps
      this.item.steps.forEach(step => {
        if (step.type === 'FLOATINPUT') {
          infos.push({ name: step.dataLabel, value: step.inputValue })
        }
      })
      return infos
    },
    missingDepartureOrArrival() {
      return !this.item.arrival || !this.item.departure
    }
  },
  created() {
    this.id = this.$router.currentRoute.params.transferId
    this.loadTransferMetaInfos()
    this.loadTransfer()
  },
  methods: {
    async loadTransferMetaInfos() {
      this.transferMetaInfos = await queryTransferMetaInfo()
    },
    async loadFilters() {
      const filtersData = await queryFiltersForTransfer(this.item.id)
      const filters = Filter.many(filtersData, 'id')
      Vue.set(this.item, 'filters', filters)
    },
    async loadTransfer() {
      const data = await queryTransfer(this.id)
      this.item = Transfer.one(data)

      if (this.user.inStaffGroup) {
        this.fetchOrder()
      }
    },
    async fetchOrder() {
      const transferId = this.id
      const orderData = await queryOrderForTransferDetails(transferId)
      const order = Order.one(orderData)
      Vue.set(this.item, 'order', order)
    },
    renderMapDelayed() {
      // we have to delay the rendering of the map until the tab is no longer hidden
      setTimeout(this.renderMap, 100)
    },
    renderMap() {
      if (!this.map) {
        this.map = new DetailMap($('#leaflet', this.$el))
        this.map.render(this.item.layers, { fitBounds: true })
      }
    },
    async generateWaybill() {
      const res = await Transfer.generateWaybill(this.id)
      window.location.replace(res.pdf)
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
</style>

<style scoped>
.icon-space {
  margin-right: 1px;
}
.card-item-icon {
  margin-right: 5px;
}
.colon-space {
  margin-right: 6px;
}
</style>
